export { NoTechnologyPlaceholder } from './NoTechnologyPlaceholder'
